import { Component } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import "./second.css";
import "./styles.css";
import { Link } from "react-router-dom";

export default class SecondSegment extends Component {
  render() {
    return (
      <>
        <div className="secondArea pt-4">
          <div className="sdwea">
            <h2>خدمات آواکس</h2>
          </div>
          <Container id="serviceContainer">
            <hr />

            <Row xl={4} lg={4} md={2} xs={2}>
              <Col>
                <Card className="serviceCard">
                  <Link to="/expresspost">
                    <img src="./icons/express.png" />
                  </Link>
                </Card>
              </Col>
              <Col>
                <Card className="serviceCard">
                  <Link to="/doortodoor">
                    <img src="./icons/doorToDoor.png" />
                  </Link>
                </Card>
              </Col>
              <Col>
                <Card className="serviceCard">
                  <Link to="/payinplace">
                    <img src="./icons/cod.png" />
                  </Link>
                </Card>
              </Col>
              <Col>
                <Card className="serviceCard">
                  <Link to="/bulkOrder">
                    <img src="./icons/bulk.png" />
                  </Link>
                </Card>
              </Col>

              <Col>
                <Card className="serviceCard">
                  <Link to="/beforRent">
                    <img src="./icons/beforePay.png" />
                  </Link>
                </Card>
              </Col>
              <Col>
                <Card className="serviceCard">
                  <Link to="/payinplace">
                    <img src="./icons/afterPay.png" />
                  </Link>
                </Card>
              </Col>
              <Col>
                <Card className="serviceCard">
                  <Link to="/onlinePayment">
                    <img src="./icons/online.png" />
                  </Link>
                </Card>
              </Col>
              <Col>
                <Card className="serviceCard">
                  <Link to="/callOrder">
                    <img src="./icons/tel.png" />
                  </Link>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}
